export const LOCATION_CHECKOUT = 'checkout'
export const LOCATION_PLANS = 'plans'
export const LOCATION_QUIZ = 'find-my-classes'
